import { useMutation } from "@tanstack/react-query";
import { uploadImageToCloud } from "../services/images.service";

export const useUploadImageToCloud = () => {
  return useMutation({
    mutationFn: uploadImageToCloud,
  });
};
